import * as yup from 'yup';

const expresionRegularPhoneNumber = /^[0-9]+$/;

export const validationSchema = yup.object({
  name: yup.string('Enter the name').required('Name is required'),
  phone_number: yup
    .string('Enter the phone number')
    .matches(
      expresionRegularPhoneNumber,
      'Phone Number is invalid, you can only use numbers with no spaces',
    )
    .required('Phone Number is required'),
  email: yup.string('Enter the email').email('Enter a valid email').required('Email is required'),
});

export const payerValidationSchema = yup.object({
  name: yup.string('Enter the name').required('Name is required'),
  phone: yup
    .string('Enter the phone number')
    .matches(
      expresionRegularPhoneNumber,
      'Phone Number is invalid, you can only use numbers with no spaces',
    )
    .required('Phone Number is required'),
  email: yup.string('Enter the email').email('Enter a valid email').required('Email is required'),
});
